import React, { Component } from "react";
import {
  loading,
  NavbarCustomer,
  GET,
  t,
} from "../../components/CustomComponent.js";
import {
  fill,
  fmtInt,
  fmtDate,
  fmtDay,
  StatusBadge,
  WarrantyBadge,
  TypeBadge,
  OpenBadge,
  EmptyBox,
  Skeleton,
  ErrorCard,
  WarrantyBars,
  TYPE_COLORS,
  TIMELINE_TYPES,
} from "../../components/AssetHistoryParts.js";
import "../../assets/css/asset-history.css";

const ACCESS_DENIED = "Access denied";
const NOT_FOUND = "Asset not found";

// ประวัติสินทรัพย์ฝั่งลูกค้า (แบบย่อ) - GET customer/asset-history/:uid
// แสดงเฉพาะที่ API ส่ง: ไม่มีต้นทุน / BU / Sales / ไฟล์แนบ / Service Report
export default class CustomerAssetHistoryDetail extends Component {
  constructor(props) {
    super(props);
    this.uid = new URLSearchParams(window.location.search).get("uid") || "";
    this.state = {
      data: null,
      fetching: true,
      error: "",
      forbidden: false,
      not_found: false,
      type_filter: "all",
      expanded: {},
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  Get = async () => {
    if (!this.uid) {
      this.setState({ fetching: false, not_found: true });
      return;
    }
    this.setState({ fetching: true, error: "", forbidden: false, not_found: false });
    const result = await GET(`customer/asset-history/${encodeURIComponent(this.uid)}`, null, true, { skipAccessDeniedAlert: true });
    if (result?.status && result.data) {
      this.setState({ data: result.data, fetching: false });
      return;
    }
    const message = typeof result?.message === "string" ? result.message : "";
    this.setState({
      data: null,
      fetching: false,
      forbidden: message === ACCESS_DENIED,
      not_found: message === NOT_FOUND,
      error: message === ACCESS_DENIED || message === NOT_FOUND ? "" : message || t("ah_error_hint"),
    });
  };

  ToggleExpand = (key) => this.setState((s) => ({ expanded: { ...s.expanded, [key]: !s.expanded[key] } }));

  renderHeader(data) {
    const { asset, summary } = data;
    const loc = asset.location || {};
    const location = [loc.name, loc.address, loc.floor_room, loc.sub_district, loc.district, loc.province, loc.zip_code].filter(Boolean).join(" ");
    const info = [
      [t("ah_d_location"), location || "-"],
      [t("ah_d_project"), asset.project_name || "-"],
      [t("ah_d_brand_model"), [asset.brand_name, asset.model_name].filter(Boolean).join(" · ") || "-", asset.part_number],
      [t("ah_d_install_date"), fmtDate(asset.install_date)],
    ];
    return (
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4" data-testid="ah-header">
        <div className="d-flex flex-wrap gap-3 align-items-start">
          <div className="ah-avatar">⚙️</div>
          <div className="flex-grow-1" style={{ minWidth: 240 }}>
            <h4 className="fw-bold text-dark mb-1" data-testid="ah-asset-name">{asset.product_name || "-"}</h4>
            <div className="text-secondary text-14" style={{ fontFamily: "monospace" }}>{asset.asset_code}{asset.serial_number ? ` · S/N ${asset.serial_number}` : ""}</div>
            <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
              <StatusBadge status={asset.status} />
              <WarrantyBadge warranty={asset.warranty} />
              {asset.has_open_work_order ? <OpenBadge count={summary.open_work_orders} /> : null}
            </div>
          </div>
        </div>
        <div className="ah-info">
          {info.map(([k, v, sub]) => (
            <div key={k}>
              <div className="k">{k}</div>
              <div className="v">{v || "-"}</div>
              {sub ? <div className="text-12 text-secondary">{sub}</div> : null}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderSummary(data) {
    const s = data.summary;
    const mtbf = s.mtbf_days === null || s.mtbf_days === undefined ? "–" : fill(t("ah_days_n"), { n: fmtInt(s.mtbf_days) });
    const tiles = [
      [fmtInt(s.total_events), t("ah_sum_total")],
      [fmtInt(s.repair_count), t("ah_sum_repairs")],
      [fmtInt(s.open_work_orders), t("ah_sum_open")],
      [mtbf, t("ah_sum_mtbf")],
    ];
    return (
      <div className="row g-3 mb-4">
        <div className="col-lg-6">
          <div className="bg-white rounded-4 shadow-sm p-4 h-100">
            <h6 className="fw-bold text-dark mb-3">🛡️ {t("ah_warranty_history")}</h6>
            <WarrantyBars items={data.warranty_history} />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="bg-white rounded-4 shadow-sm p-4 h-100">
            <h6 className="fw-bold text-dark mb-3 d-flex">📊 {t("ah_summary")}<span className="text-12 text-secondary fw-normal ms-auto">{t("ah_summary_lifetime")}</span></h6>
            <div className="ah-mk" data-testid="ah-summary">
              {tiles.map(([v, l]) => (
                <div key={l}><div className="v">{v}</div><div className="l">{l}</div></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderEvent(e, i) {
    const { expanded } = this.state;
    const key = e.uid || `${e.number}-${i}`;
    const open = !!expanded[key];
    const techs = (e.technicians || []).map((x) => x.name).filter(Boolean).join(", ");
    const parts = e.parts || [];
    return (
      <div className="ah-ev" key={key} style={{ "--ec": TYPE_COLORS[e.type] || "#999" }} data-testid="ah-event">
        <div className="top">
          <span className="fw-semibold">{fmtDay(e.date)}</span>
          <span className="wo">{e.number}</span>
          <TypeBadge type={e.type} />
          {e.is_open ? <span className="ah-bd open">● {t("ah_in_progress")}</span> : null}
        </div>
        <div className="ev-grid">
          <div><div className="k">{t("ah_ev_symptom")}</div>{e.symptom || "-"}</div>
          <div><div className="k">{t("ah_ev_resolution")}</div>{e.resolution || "-"}</div>
          <div><div className="k">{t("ah_ev_technician")}</div>{techs ? `👷 ${techs}` : "-"}</div>
        </div>
        <button type="button" className="ah-link-btn" onClick={() => this.ToggleExpand(key)} data-testid="ah-toggle">{t("ah_ev_more_cs")} {open ? "▴" : "▾"}</button>
        {open ? (
          <div className="more" data-testid="ah-more">
            {parts.length ? (
              <div className="table-responsive">
                <table className="table table-sm align-middle mb-0 ah-table">
                  <thead>
                    <tr className="text-dark fw-bold border-bottom border-light">
                      <th className="border-0">{t("ah_part_name")}</th>
                      <th className="border-0 num">{t("ah_part_qty")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parts.map((p, j) => (
                      <tr key={j} className="border-bottom border-light">
                        <td className="wrap">{p.name || "-"}<div className="sub">{p.part_number}</div></td>
                        <td className="num">{fmtInt(p.quantity)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : <div className="text-12 text-secondary">{t("ah_no_parts")}</div>}
            {e.signature?.signed ? <div className="mt-3"><span className="ah-bd in">✍ {t("ah_signed")}{e.signature.signee_name ? ` · ${e.signature.signee_name}` : ""}</span></div> : null}
          </div>
        ) : null}
      </div>
    );
  }

  renderTimeline(data) {
    const { type_filter } = this.state;
    const all = data.timeline || [];
    const list = type_filter === "all" ? all : all.filter((e) => e.type === type_filter);
    const countOf = (type) => all.filter((e) => e.type === type).length;
    const chips = [["all", t("ah_filter_all"), all.length], ...TIMELINE_TYPES.map((x) => [x, t(`ah_type_${x}`), countOf(x)])];
    return (
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
        <h6 className="fw-bold text-dark mb-3 d-flex">🔧 {t("ah_timeline")}<span className="text-12 text-secondary fw-normal ms-auto">{fill(t("ah_items_n"), { n: list.length })}</span></h6>
        <div className="ah-filters">
          {chips.map(([key, label, n]) => (
            <button key={key} type="button" className={type_filter === key ? "on" : ""} onClick={() => this.setState({ type_filter: key })} data-testid={`ah-chip-${key}`}>{label} ({n})</button>
          ))}
        </div>
        {!list.length ? <EmptyBox icon="🔧" title={t(all.length ? "ah_timeline_empty_type" : "ah_timeline_empty")} /> : <div className="ah-tl">{list.map((e, i) => this.renderEvent(e, i))}</div>}
      </div>
    );
  }

  renderBody() {
    const { data, fetching, error, forbidden, not_found } = this.state;
    if (forbidden || not_found) {
      return (
        <div className="bg-white rounded-4 shadow-sm p-5 text-center" data-testid={forbidden ? "ah-forbidden" : "ah-not-found"}>
          <h4 className="fw-bold text-dark">{t(forbidden ? "ah_forbidden_asset" : "ah_not_found")}</h4>
          <a className="btn btn-primary px-4 py-2 mt-3 fw-bold rounded-3" href="/cs/asset-report">{t("ah_back_list")}</a>
        </div>
      );
    }
    if (error) return <ErrorCard message={error} onRetry={this.Get} />;
    if (fetching || !data) return <Skeleton heights={[200, 160, 360]} />;
    return (
      <>
        {this.renderHeader(data)}
        {this.renderSummary(data)}
        {this.renderTimeline(data)}
      </>
    );
  }

  render() {
    return (
      <div className="w-100 min-vh-100 pb-5" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body px-4 mt-3">
          <a href="/cs/asset-report" className="d-inline-block mb-3 text-decoration-none fw-semibold" style={{ color: "#2A55E5" }} data-testid="ah-back">‹ {t("ah_back_list")}</a>
          {this.renderBody()}
        </div>
      </div>
    );
  }
}
